/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_Metric_LoadInputs */

const en_us2_exercise_personal_goal_metric_load = /** @type {(inputs: Exercise_Personal_Goal_Metric_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heaviest weight`)
};

const pt_br2_exercise_personal_goal_metric_load = /** @type {(inputs: Exercise_Personal_Goal_Metric_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior peso`)
};

const es_419_exercise_personal_goal_metric_load = /** @type {(inputs: Exercise_Personal_Goal_Metric_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor peso`)
};

const pt_pt2_exercise_personal_goal_metric_load = /** @type {(inputs: Exercise_Personal_Goal_Metric_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior peso`)
};

const fr_fr2_exercise_personal_goal_metric_load = /** @type {(inputs: Exercise_Personal_Goal_Metric_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge max`)
};

const de_de2_exercise_personal_goal_metric_load = /** @type {(inputs: Exercise_Personal_Goal_Metric_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstes Gewicht`)
};

const it_it2_exercise_personal_goal_metric_load = /** @type {(inputs: Exercise_Personal_Goal_Metric_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso più alto`)
};

/**
* | output |
* | --- |
* | "Heaviest weight" |
*
* @param {Exercise_Personal_Goal_Metric_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_metric_load = /** @type {((inputs?: Exercise_Personal_Goal_Metric_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_Metric_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_metric_load(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_metric_load(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_metric_load(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_metric_load(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_metric_load(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_metric_load(inputs)
	return en_us2_exercise_personal_goal_metric_load(inputs)
});
export { exercise_personal_goal_metric_load as "exercise-personal.goal_metric_load" }